const categories = [
    {
      name: 'all',
      text: '전체',
    },
    {
      name: 'online',
      text: '정상',
    },
    {
      name: 'offline',
      text: '오프라인',
    },
    {
      name: 'error',
      text: '오류',
    }
];

export default categories;